import React from "react";
import { Avatar, Button, Card, Divider, Layout, Menu, Space, Typography } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import type { User } from "../../../types";

const { Sider } = Layout;
const { Text } = Typography;

interface AdminSidebarProps {
  selectedKey: string;
  items: MenuProps["items"];
  onSelect: (key: string) => void;
  isMobile?: boolean;
  currentUser?: User | null;
  profileLoading?: boolean;
  onProfile?: () => void;
  onLogout?: () => void;
  isDark?: boolean;
}

export const AdminSidebar: React.FC<AdminSidebarProps> = ({
  selectedKey,
  items,
  onSelect,
  isMobile,
  currentUser,
  profileLoading,
  onProfile,
  onLogout,
  isDark,
}) => {
  const content = (
    <Card variant="borderless" className="admin-console__sider-card">
      <div className="admin-console__sider-content">
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          items={items}
          onClick={({ key }) => onSelect(key)}
        />
      </div>

      {isMobile && (
        <div className="admin-console__sider-footer">
          <Divider style={{ margin: "12px 0" }} />
          <Space direction="vertical" style={{ width: "100%" }} size="middle">
            <div className="admin-console__sidebar-user" onClick={onProfile}>
              <Avatar icon={<UserOutlined />} src={currentUser?.image} />
              <div className="admin-console__sidebar-user-info">
                <Text strong style={{ display: "block" }}>{currentUser?.fullName || currentUser?.username}</Text>
                <Text type="secondary" style={{ fontSize: "12px" }}>View Profile</Text>
              </div>
            </div>
            <Button
              danger
              icon={<LogoutOutlined />}
              onClick={onLogout}
              style={{ width: "100%" }}
            >
              Logout
            </Button>
          </Space>
        </div>
      )}
    </Card>
  );

  if (isMobile) {
    return (
      <div className={`admin-console ${!isDark ? "admin-console--light" : ""} admin-console__sidebar-mobile-wrapper`}>
        {content}
      </div>
    );
  }

  return (
    <Sider width="20%" className="admin-console__sider">
      {content}
    </Sider>
  );
};

